export default __webpack_public_path__ + "30ff99699b149b0078b06de18a96caf3.png";